import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "subtitle-3" }
const _hoisted_2 = { class: "grey-form-card" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Delete")
const _hoisted_4 = { class: "button-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_form, {
    "label-position": "top",
    "label-width": "100px",
    model: _ctx.form,
    rules: _ctx.rules,
    ref: "contactForm"
  }, {
    default: _withCtx(() => [
      _createVNode("h3", _hoisted_1, "Contact Person " + _toDisplayString(_ctx.index + 1), 1),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_el_form_item, {
          label: "First name",
          prop: "first_name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.first_name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.first_name = $event)),
              maxlength: 30
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "Last name",
          prop: "last_name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.last_name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.last_name = $event)),
              maxlength: 30
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "Job title",
          prop: "title"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.title,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.title = $event)),
              maxlength: 50
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "Email",
          prop: "email"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.email,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.email = $event)),
              maxlength: 40
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.form.phone_numbers, (phone, index) => {
          return (_openBlock(), _createBlock(_component_el_form_item, {
            class: "parent-item",
            key: index
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    class: "phone-code-input",
                    label: "Country code",
                    prop: 'phone_numbers.' + index + '.country_code',
                    rules: _ctx.country_code_rules
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: phone.country_code,
                        "onUpdate:modelValue": ($event: any) => (phone.country_code = $event),
                        maxlength: 4
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["prop", "rules"])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_el_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    class: "phone-number-input",
                    label: "Phone number",
                    prop: 'phone_numbers.' + index + '.phone_number',
                    rules: _ctx.phone_number_rules
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: phone.phone_number,
                        "onUpdate:modelValue": ($event: any) => (phone.phone_number = $event),
                        maxlength: 10
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["prop", "rules"])
                ]),
                _: 2
              }, 1024),
              (_ctx.form.phone_numbers.length > 1)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    onClick: _withModifiers(($event: any) => (_ctx.removePhone(index)), ["prevent"])
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024))
        }), 128)),
        _createVNode("a", {
          href: "#",
          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.addPhone()), ["prevent"]))
        }, "+ Add phone number")
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("button", {
          class: "button secondary",
          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.cancel()), ["prevent"]))
        }, " Cancel "),
        _withDirectives(_createVNode("button", {
          class: "button",
          disabled: !_ctx.isRequiredFilled,
          onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.submitForm()), ["prevent"]))
        }, " Save ", 8, ["disabled"]), [
          [
            _directive_loading,
            _ctx.state.loading,
            void 0,
            {
              fullscreen: true,
              lock: true
            }
          ]
        ])
      ])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}